import { gql, useMutation } from '@apollo/client'

const QUESTION_DELETE_MUTATION = gql`
  mutation questionDelete($questionId: Long!) {
    questionDelete(id: $questionId) {
      success
    }
  }
`

export function useQuestionDeleteMutation(questionId) {
  const [mutation] = useMutation(QUESTION_DELETE_MUTATION, {
    variables: { questionId },
    update(cache, { data: { addTodo } }) {
      cache.modify({
        fields: {
          questionList(existing = [], { readField }) {
            return {
              ...existing,
              results: existing.results.filter(ref => questionId === readField('id', ref))
            }
          }
        }
      })
    }
  })

  return [mutation]
}
